import * as React from 'react';
import { RouteComponentProps } from 'react-router';

import { getPrivilegesTo } from '../../helpers/Users/getPrivilegesTo';
import { privileges } from 'data-layer/src/services/Users/privileges';
import UsersTable from './UsersTable';
import NoAccess from '../NoAccess/NoAccess';

interface IUsersProps extends RouteComponentProps<{
  eshop: string;
  userId: string;
}> {

}

export default class Users extends React.Component<IUsersProps> {

  public render() {

    if (!getPrivilegesTo(privileges.USER_MANAGEMENT)) {
      return <NoAccess domain={this.props.match.params.eshop} />
    }

    return (
      <div>
        <UsersTable
          domain={this.props.match.params.eshop}
          userId={this.props.match.params.userId}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Users/index.tsx